import { ADMINS_DIT_PATH, ADMINS_DIT_EVENT_PATH } from '../../utils/constants';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';

import React from 'react';
import { DitDashboard } from './components/DitDashboard';
import { DitEventDetails } from './components/DitEventDetails';

export const DataIngestionTool = () => {
  return (
    <Switch path={ADMINS_DIT_PATH}>
      <Route exact path={ADMINS_DIT_PATH} component={DitDashboard} />
      <Route exact path={ADMINS_DIT_EVENT_PATH} component={DitEventDetails} />
    </Switch>
  );
};
